import { NAV_ITEMS, NavGroup, NavItem, NavLeaf } from "@/consts";

export const isNavGroup = (item: NavItem): item is NavGroup =>
	"children" in item;

export const filterNavItems = (
	items: NavItem[],
	permissions: string[],
): NavItem[] =>
	items.flatMap((item): NavItem[] => {
		if (!isNavGroup(item)) {
			return permissions.includes(item.tab) ? [item] : [];
		}
		const children = item.children.filter((child) =>
			permissions.includes(child.tab),
		);
		return children.length ? [{ ...item, children }] : [];
	});

export const getFirstAllowedRoute = (permissions: string[]) =>
	filterNavItems(NAV_ITEMS, permissions).flatMap((item): NavLeaf[] =>
		isNavGroup(item) ? item.children : [item],
	)[0]?.to;
